module.exports = __webpack_public_path__ + "static/media/bloco1img6.bc7fee27.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/EVisual/bloco1img6.png
// module id = 119
// module chunks = 0